__turbopack_context__.v({
  "carousel-arrow-buttons": "EZbb7a_carousel-arrow-buttons",
  "carousel-arrow-buttons--secondary": "EZbb7a_carousel-arrow-buttons--secondary",
  "carousel-arrow-buttons__arrow--right": "EZbb7a_carousel-arrow-buttons__arrow--right",
  "carousel-arrow-buttons__button": "EZbb7a_carousel-arrow-buttons__button",
  "carousel-arrow-buttons__button--icon": "EZbb7a_carousel-arrow-buttons__button--icon",
  "carousel-arrow-buttons__button--icon--selected": "EZbb7a_carousel-arrow-buttons__button--icon--selected",
  "carousel-arrow-buttons__button--inverted": "EZbb7a_carousel-arrow-buttons__button--inverted",
  "carousel-arrow-buttons__button--plain": "EZbb7a_carousel-arrow-buttons__button--plain",
  "carousel-arrow-buttons__button--secondary": "EZbb7a_carousel-arrow-buttons__button--secondary",
  "carousel-arrow-buttons__button--small": "EZbb7a_carousel-arrow-buttons__button--small",
  "carousel-arrow-buttons__button--tertiary": "EZbb7a_carousel-arrow-buttons__button--tertiary",
  "carousel-arrow-buttons__button__prefix": "EZbb7a_carousel-arrow-buttons__button__prefix",
  "carousel-arrow-buttons__button__suffix": "EZbb7a_carousel-arrow-buttons__button__suffix",
});
